import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { CopyService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'ds-equipment-list',
  templateUrl: './equipment-list.component.html',
  styleUrls: ['./equipment-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EquipmentListComponent implements OnInit {
  @Input() equipmentList: string[];
  @Input() isPartner: boolean;
  @Input() userState: string;

  newVehicleFeaturesAndEquipmentAntiTheftEligibleStatesForPartnersWithCategories =
    this.copyService.getCopy(
      'policy.newVehicleFeaturesAndEquipmentAntiTheftEligibleStatesForPartnersWithCategories'
    );
  outOfContextItems = ['Anti-Theft Device - Active', 'Anti-Theft Device - Passive'];

  constructor(private copyService: CopyService) {}

  ngOnInit() {
    if (
      this.isPartner &&
      this.newVehicleFeaturesAndEquipmentAntiTheftEligibleStatesForPartnersWithCategories.includes(
        this.userState
      )
    ) {
      this.equipmentList = this.equipmentList.filter(
        elem => !this.outOfContextItems.includes(elem)
      );
    }
  }
}
